import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    addInterviewPreparationAdmin,
    deleteInterviewPreparationAdmin,
    fetchInterviewPreparationAdmin,
    updateInterviewPreparationAdmin,
} from "./InterviewPreparationAdminAPI";

export const fetchInterviewPreparationAdminasync = createAsyncThunk(
    "interviewPreparationAdmin/fetch",
    async (_, { rejectWithValue }) => {
        try {
            return await fetchInterviewPreparationAdmin();
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const addInterviewPreparationAdminAsync = createAsyncThunk(
    "interviewPreparationAdmin/add",
    async (newItem, { rejectWithValue }) => {
        try {
            return await addInterviewPreparationAdmin(newItem);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// UPDATED: accept { uuid, data } and support FormData (handled in API via POST + _method=PUT)
export const updateInterviewPreparationAdminAsync = createAsyncThunk(
    "interviewPreparationAdmin/update",
    async ({ uuid, data }, { rejectWithValue }) => {
        try {
            return await updateInterviewPreparationAdmin(uuid, data);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const deleteInterviewPreparationAdminAsync = createAsyncThunk(
    "interviewPreparationAdmin/delete",
    async (uuid, { rejectWithValue }) => {
        try {
            return await deleteInterviewPreparationAdmin(uuid);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const InterviewPreparationAdminSlice = createSlice({
    name: "interviewPreparationAdmin",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch
            .addCase(fetchInterviewPreparationAdminasync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchInterviewPreparationAdminasync.fulfilled, (state, action) => {
                state.loading = false;
                state.data =
                    action.payload?.response ??
                    action.payload?.data?.response ??
                    [];
            })
            .addCase(fetchInterviewPreparationAdminasync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Add
            .addCase(addInterviewPreparationAdminAsync.pending, (state) => {
                state.loading = true;
            })
            .addCase(addInterviewPreparationAdminAsync.fulfilled, (state, action) => {
                state.loading = false;
                const server = action.payload?.response ?? action.payload?.data ?? null;
                if (!server) return;
                if (Array.isArray(server)) state.data.unshift(...server);
                else state.data.unshift(server);
            })
            .addCase(addInterviewPreparationAdminAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Update
            .addCase(updateInterviewPreparationAdminAsync.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateInterviewPreparationAdminAsync.fulfilled, (state, action) => {
                state.loading = false;
                const { uuid, data: patch } = action.meta.arg;
                const server = action.payload?.response ?? action.payload?.data ?? null;

                const idx = state.data.findIndex((i) => i?.uuid === uuid || i?.id === uuid);
                if (idx === -1) return;

                if (server && (server.uuid || server.id)) {
                    state.data[idx] = server;
                } else {
                    const canPatch = patch && !(typeof FormData !== "undefined" && patch instanceof FormData);
                    if (canPatch) {
                        state.data[idx] = { ...state.data[idx], ...patch };
                    }
                }
            })
            .addCase(updateInterviewPreparationAdminAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Delete
            .addCase(deleteInterviewPreparationAdminAsync.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteInterviewPreparationAdminAsync.fulfilled, (state, action) => {
                state.loading = false;
                const uuid = action.meta.arg;
                state.data = state.data.filter((item) => item.uuid !== uuid && item.id !== uuid);
            })
            .addCase(deleteInterviewPreparationAdminAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const selectInterviewPreparationAdmin = (state) =>
    state.interviewPreparationAdmin.data;
export const selectInterviewPreparationAdminLoading = (state) =>
    state.interviewPreparationAdmin.loading;

export default InterviewPreparationAdminSlice.reducer;